export default "__VITE_ASSET__DdTRFu3l__"